import script from "./NoteList.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteList.vue?vue&type=script&setup=true&lang=js"

import "./NoteList.vue?vue&type=style&index=0&id=70a11b99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a11b99"]])

export default __exports__